import { FETCH_REVIEWS } from '../actions/types';

export default function reviewsReducer(state = [], action) {
	switch (action.type) {
		case FETCH_REVIEWS:
			return action.payload || [];
		default:
			return state;
	}
}
